import React from 'react';
import PropTypes from 'prop-types';

import styles from './lineItem.scss';

const LineItem = ({ invoiceItems }) => {
    if (!invoiceItems || !invoiceItems.lineItems || invoiceItems.lineItems.length === 0) {
        return null;
    }

    return (
        <div className={styles.lineItemSection}>
            {invoiceItems?.lineItems?.map((item, i) => (
                <div className="d-flex flex-row" key={`lineItem-${i}`}>
                    <div className={`flex-grow-1 ${styles.itemName}`}>
                        {item?.description}
                    </div>
                    <div className={`align-content-end ${styles.total}`}>
                        <span>
                            {item?.amount < 0
                                ? `(${item?.currency}${Math.abs(item?.amount).toFixed(2)})`
                                : `${item?.currency}${item?.amount?.toFixed(2)}`}
                        </span>
                        {invoiceItems?.lineItems?.length === 1 && ' total'}
                    </div>
                </div>
            ))}

            {invoiceItems?.lineItems?.length > 1 && invoiceItems?.total && (
                <div className="d-flex flex-row">
                    <div className={`flex-grow-1 ${styles.itemName}`}>Final Amount</div>
                    <div className={`align-content-end ${styles.total}`}>
                        <span>{invoiceItems?.total?.currency}{invoiceItems?.total?.amount?.toFixed(2)}</span> total
                    </div>
                </div>
            )}
        </div>
    );
};

LineItem.propTypes = {
    invoiceItems: PropTypes.shape({
        lineItems: PropTypes.arrayOf(PropTypes.shape({
            description: PropTypes.string.isRequired,
            amount: PropTypes.number.isRequired,
            currency: PropTypes.string.isRequired,
        })).isRequired,
        total: PropTypes.shape({
            amount: PropTypes.number.isRequired,
            currency: PropTypes.string.isRequired,
        }),
    }),
};

export default LineItem;
